export default "/images/vendor/flag-icon-css/flags/4x3/dj.svg?015c67e78d7c8cb05d7f94cd4fc68f67";